module.exports = __webpack_public_path__ + "img/gadol_yes.1fca80a8.png";